import { render, staticRenderFns } from "./UsersList.vue?vue&type=template&id=a45d8206&scoped=true&"
import script from "./UsersList.vue?vue&type=script&lang=js&"
export * from "./UsersList.vue?vue&type=script&lang=js&"
import style0 from "./UsersList.vue?vue&type=style&index=0&id=a45d8206&prod&lang=scss&scoped=true&"
import style1 from "./UsersList.vue?vue&type=style&index=1&id=a45d8206&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45d8206",
  null
  
)

export default component.exports